<div #outsideModal class="modal historique-modal">
  <div #modalBody class="modal-content historique-content">

    <div class="historique-header">
      <div class="historique-header__title">
        Historique / suivi des critères
      </div>

      <button
        type="button"
        class="historique-header__close"
        title="Fermer"
        (click)="closeAddEditModal()">
        ✕
      </button>
    </div>

    <div class="historique-body">

      <aside class="historique-sidebar">

        <div class="historique-sidebar__title">
          Critères de la maquette
        </div>

        <div class="historique-search">
          <mat-icon class="historique-search__icon">search</mat-icon>

          <input
            type="text"
            class="historique-search__input"
            placeholder="Rechercher un critère..."
            autocomplete="off"
            [value]="searchTerm"
            (input)="onSearchCritere($event)">

          <button
            type="button"
            class="historique-search__clear"
            title="Effacer"
            *ngIf="searchTerm"
            (click)="clearSearch()">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <div class="historique-criteres">

          <div
            class="historique-empty historique-empty--small"
            *ngIf="filteredCriteres.length === 0">
            Aucun critère trouvé
          </div>

          <button
            type="button"
            class="historique-critere"
            *ngFor="let critere of filteredCriteres; trackBy: trackByCritere"
            [class.historique-critere--active]="selectedCritere && selectedCritere.idCritere === critere.idCritere"
            (click)="selectCritere(critere)">

            <span class="historique-critere__marker"></span>

            <span class="historique-critere__name">
              {{ critere.nomCritere }}
            </span>

            <span class="historique-critere__name">
              {{ critere.nomCritere }}
            </span>

            <span
              class="historique-critere__type"
              [class.historique-critere__type--numeric]="isNumericItem(critere)"
              [class.historique-critere__type--alpha]="!isNumericItem(critere)">
              {{ isNumericItem(critere) ? '123' : 'ABC' }}
            </span>

            <span
              class="historique-critere__unit"
              *ngIf="critere.uniteCritere">
              {{ critere.uniteCritere }}
            </span>

          </button>

        </div>

      </aside>

      <main class="historique-main">

        <ng-container *ngIf="selectedCritere; else noCritere">

          <div class="historique-top">

            <div class="historique-selected">
              <div class="historique-selected__label">
                Critère sélectionné
              </div>

              <div class="historique-selected__title">
                {{ selectedCritere.nomCritere }}

                <span
                  class="historique-selected__unit"
                  *ngIf="selectedCritere.uniteCritere">
                  {{ selectedCritere.uniteCritere }}
                </span>
              </div>
            </div>

            <div class="historique-filters">

              <button
                type="button"
                class="historique-filter"
                [class.historique-filter--active]="filterMode === 'last10'"
                (click)="setFilter('last10')">
                10 derniers
              </button>

              <button
                type="button"
                class="historique-filter"
                [class.historique-filter--active]="filterMode === 'last20'"
                (click)="setFilter('last20')">
                20 derniers
              </button>

              <button
                type="button"
                class="historique-filter"
                [class.historique-filter--active]="filterMode === 'all'"
                (click)="setFilter('all')">
                Tous
              </button>

              <button
                type="button"
                class="historique-filter"
                [class.historique-filter--active]="filterMode === 'period'"
                (click)="setFilter('period')">
                Personnalisé
              </button>

            </div>

          </div>

          <div
            class="historique-all-warning"
            *ngIf="filterMode === 'all'">
            <mat-icon>info_outline</mat-icon>
            <span>
              L'affichage de l'ensemble de l'historique peut prendre quelques secondes pour un dossier comportant de nombreuses données.
            </span>
          </div>

          <div
            class="historique-period"
            *ngIf="filterMode === 'period'">

            <div class="historique-period__field">
              <label>Date de début</label>
              <input
                type="date"
                [value]="dateDebut"
                (change)="dateDebut = $event.target.value">
            </div>

            <div class="historique-period__field">
              <label>Date de fin</label>
              <input
                type="date"
                [value]="dateFin"
                (change)="dateFin = $event.target.value">
            </div>

            <button
              type="button"
              class="historique-period__apply"
              [disabled]="loading"
              (click)="applyPeriod()">
              Appliquer
            </button>

            <div
              class="historique-period__error"
              *ngIf="periodError">
              {{ periodError }}
            </div>

          </div>

          <div
            class="historique-loading"
            *ngIf="loading">
            <mat-icon>hourglass_empty</mat-icon>
            Chargement de l'historique...
          </div>

          <div
            class="historique-error"
            *ngIf="!loading && loadError">
            <mat-icon>error_outline</mat-icon>
            {{ loadError }}
          </div>

          <div
            class="historique-empty"
            *ngIf="!loading && !loadError && historique.length === 0">
            <mat-icon>timeline</mat-icon>
            <div>Aucun historique disponible pour ce critère.</div>
          </div>

          <ng-container *ngIf="!loading && !loadError && historique.length > 0">

            <section
              class="historique-card historique-graph-card"
              *ngIf="isNumericCritere()">

              <div class="historique-card__header">
                <div>
                  <div class="historique-card__title">
                    Évolution
                  </div>
                  <div class="historique-card__subtitle">
                    {{ getFilterLabel() }}
                  </div>
                </div>

                <div class="historique-card__count">
                  {{ historique.length }}
                  résultat{{ historique.length > 1 ? 's' : '' }}
                </div>
              </div>

              <div #chartPrintSource class="historique-chart-container">
                <google-chart
                  *ngIf="chart.data.length > 0"
                  class="historique-google-chart"
                  [title]="chart.title"
                  [type]="chart.type"
                  [data]="chart.data"
                  [options]="chart.options"
                  [dynamicResize]="true">
                </google-chart>
              </div>

              <div
                class="historique-empty historique-empty--inside"
                *ngIf="chart.data.length === 0">
                Les valeurs enregistrées ne peuvent pas être représentées numériquement.
              </div>

            </section>

            <section
              class="historique-card"
              *ngIf="showTimeline()">

              <div class="historique-card__header">
                <div>
                  <div class="historique-card__title">
                    Évolution
                  </div>
                  <div class="historique-card__subtitle">
                    {{ getFilterLabel() }}
                  </div>
                </div>

                <div class="historique-card__count">
                  {{ historique.length }}
                  résultat{{ historique.length > 1 ? 's' : '' }}
                </div>
              </div>

              <div class="historique-timeline-scroll">
                <div class="historique-timeline">

                  <div
                    class="historique-timeline__item"
                    *ngFor="let ligne of historique; let last = last; trackBy: trackByHistorique">

                    <div
                      class="historique-timeline__line"
                      *ngIf="!last">
                    </div>

                    <div class="historique-timeline__date">
                      {{ formatDate(ligne.date) }}
                    </div>

                    <div class="historique-timeline__dot"></div>

                    <div
                      class="historique-timeline__value"
                      [title]="ligne.valeur">
                      {{ ligne.valeur }}
                    </div>

                  </div>

                </div>
              </div>

            </section>

            <section
              class="historique-card historique-text-card"
              *ngIf="showTextOnly()">

              <div class="historique-card__header">
                <div>
                  <div class="historique-card__title">
                    Historique textuel
                  </div>
                  <div class="historique-card__subtitle">
                    {{ getFilterLabel() }}
                  </div>
                </div>

                <div class="historique-card__count">
                  {{ historique.length }}
                  résultat{{ historique.length > 1 ? 's' : '' }}
                </div>
              </div>

              <div class="historique-text-card__info">
                Les valeurs de ce critère sont présentées dans le tableau chronologique ci-dessous.
              </div>

            </section>

            <section class="historique-card historique-table-card">

              <div class="historique-card__header">
                <div>
                  <div class="historique-card__title">
                    Valeurs
                  </div>
                  <div class="historique-card__subtitle">
                    De la plus récente à la plus ancienne
                  </div>
                </div>
              </div>

              <div class="historique-table-wrapper">
                <table class="historique-table">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Valeur</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      *ngFor="let ligne of historiqueTable; trackBy: trackByHistorique">
                      <td class="historique-table__date">
                        {{ formatDate(ligne.date) }}
                      </td>

                      <td class="historique-table__value">
                        {{ ligne.valeur }}
                        <span
                          class="historique-table__unit"
                          *ngIf="selectedCritere.uniteCritere">
                          {{ selectedCritere.uniteCritere }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </section>

          </ng-container>

        </ng-container>

        <ng-template #noCritere>
          <div class="historique-empty">
            Aucun critère disponible dans cette maquette.
          </div>
        </ng-template>

      </main>

    </div>

    <div class="historique-footer">

      <div class="historique-footer__info">
        <ng-container *ngIf="selectedCritere && historique.length > 0">
          {{ historique.length }} résultat{{ historique.length > 1 ? 's' : '' }} affiché{{ historique.length > 1 ? 's' : '' }}
        </ng-container>
      </div>

      <div class="historique-footer__actions">

        <button
          type="button"
          class="historique-button historique-button--secondary"
          [disabled]="historique.length === 0 || loading"
          (click)="print()">
          <mat-icon>print</mat-icon>
          Imprimer
        </button>

        <button
          type="button"
          class="historique-button historique-button--primary"
          (click)="closeAddEditModal()">
          Fermer
        </button>

      </div>

    </div>

  </div>
</div>

<div class="modal-background"></div>
